import Model from 'flarum/Model';

export default class GIF extends Model {
    gifID = Model.attribute('gifID');
}
